export const SIDEBAR_GROUPS_DIALOG_ROOT = 'sidebar-groups-dialog-root';
